module.exports = __webpack_public_path__ + "img/ordersurplus.c5e5d34d.png";